import { render, staticRenderFns } from "./Downlines.vue?vue&type=template&id=06bd74e0&"
import script from "./Downlines.vue?vue&type=script&lang=js&"
export * from "./Downlines.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports